interface ZoneOption {
  id: string;
  /** "UTC+3" */
  offset: string;
  /** Wall clock there right now, "17:32". */
  time: string;
}

function offsetOf(zone: string, now: Date): string {
  const name =
    new Intl.DateTimeFormat("en-US", {
      timeZone: zone,
      timeZoneName: "shortOffset",
    })
      .formatToParts(now)
      .find((part) => part.type === "timeZoneName")?.value ?? "GMT";
  return name.replace("GMT", "UTC");
}

function clockIn(zone: string, now: Date): string {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: zone,
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).format(now);
}

/** IANA zones matching the query, each with its offset and current time. */
export function findZones(
  query: string,
  now: Date = new Date(),
  limit = 50,
): { total: number; zones: ZoneOption[] } {
  const needle = query.trim().toLowerCase().replaceAll(" ", "_");
  const matches = Intl.supportedValuesOf("timeZone").filter((zone) =>
    zone.toLowerCase().includes(needle),
  );
  return {
    total: matches.length,
    zones: matches.slice(0, limit).map((id) => ({
      id,
      offset: offsetOf(id, now),
      time: clockIn(id, now),
    })),
  };
}
